import VueRouter from 'vue-router'
import router, * as routes from './base'

const routerHelper: {
  [index: string]: Function
} = {}

interface HelperMethod {
  (router: VueRouter, ...params: any[]): any
}

function currying(helperMethod: HelperMethod) {
  return function (...params: any[]) {
    helperMethod(router, ...params)
  }
}

function buildRouterHelper(routes: object) {
  for (const key in routes) {
    if (key !== 'default') {
      const route = (routes as any)[key]
      for (const methodName in route) {
        const method = route[methodName]
        if (typeof method === 'function') {
          routerHelper[methodName] = currying(method)
        }
      }
    }
  }
}

buildRouterHelper(routes)
buildRouterHelper(routes.customRouter)
buildRouterHelper(routes.organizationRouter)

export default routerHelper
